import { useRef } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'

import { useRouter } from 'next/router'

export default function useScrollToPage() {
  const articleBottomRef = useRef()
  const router = useRouter()
  useIsomorphicLayoutEffect(() => {
    if (articleBottomRef.current && parseInt(router.query.page) > 0) {
      const top =
        articleBottomRef.current.getBoundingClientRect().top +
        window.scrollY -
        window.innerHeight * 0.7
      window.scrollTo({ top, behavior: 'smooth' })
    }
  }, [])

  return [articleBottomRef]
}
